import React from "react";

import { Route, Switch } from "react-router-dom";

import { PROJECTS_ROUTE } from "./routes";
import { COMPONENT_TYPES } from "../../constants/componentType";
import HeaderFooterDisposition from "../../pages/platform/components/HeaderFooterDisposition";
import PageEdit from "../../pages/platform/components/page/PageEdit";
import FAQComponentPage from "../../pages/platform/FAQComponentPage";
import PlatformComponentCarouselOrMosaic from "../../pages/platform/PlatformComponentCarouselOrMosaic";
import PlatformComponentHighlight from "../../pages/platform/PlatformComponentHighlight";
import PlatformComponentWidget from "../../pages/platform/PlatformComponentWidget";
import PlatformIndex from "../../pages/platform/PlatformIndex";
import PlatformPageEdit from "../../pages/platform/PlatformPageEdit";
import ShortcutComponentPage from "../../pages/platform/ShortcutComponentPage";

import type { JSX } from "react";

import type { Platform } from "../../api/ProjectAPI.types";

export interface PlatformRoutesParams {
  projectSlug: string;
  platform: Platform;
  pageId: string;
  componentId: string;
}

function ContentRoutes(): JSX.Element {
  const { HIGHLIGHT, FAQ, SHORTCUT, WIDGET, CAROUSEL, MOSAIC } =
    COMPONENT_TYPES;
  return (
    <Switch>
      <Route
        exact
        component={PlatformIndex}
        path={`${PROJECTS_ROUTE}/:projectSlug/layout`}
      />
      <Route
        exact
        component={PageEdit}
        path={`${PROJECTS_ROUTE}/:projectSlug/layout/pages/:pageId/:platform?`} // TODO Remove "pages" when legacy route are updated
      />
      <Route
        component={FAQComponentPage}
        path={`${PROJECTS_ROUTE}/:projectSlug/layout/pages/:pageId/:platform/${FAQ}/:componentId`}
      />
      <Route
        component={ShortcutComponentPage}
        path={`${PROJECTS_ROUTE}/:projectSlug/layout/pages/:pageId/:platform/${SHORTCUT}/:componentId`}
      />
      <Route
        component={PlatformComponentHighlight}
        path={`${PROJECTS_ROUTE}/:projectSlug/layout/pages/:pageId/:platform/${HIGHLIGHT}/:componentId`}
      />
      <Route
        component={PlatformComponentWidget}
        path={`${PROJECTS_ROUTE}/:projectSlug/layout/pages/:pageId/:platform/${WIDGET}/:componentId`}
      />
      <Route
        path={`${PROJECTS_ROUTE}/:projectSlug/layout/pages/:pageId/:platform/${MOSAIC}/:componentId`}
      >
        <PlatformComponentCarouselOrMosaic initialComponentType="mosaic" />
      </Route>
      <Route
        path={`${PROJECTS_ROUTE}/:projectSlug/layout/pages/:pageId/:platform/${CAROUSEL}/:componentId`}
      >
        <PlatformComponentCarouselOrMosaic initialComponentType="carousel" />
      </Route>
      <Route path={`${PROJECTS_ROUTE}/:projectSlug/layout/pages/:pageId`}>
        <PlatformComponentCarouselOrMosaic initialComponentType="carousel" />
      </Route>
      <Route
        exact
        path={`${PROJECTS_ROUTE}/:projectSlug/layout/page/header_footer`}
      >
        <HeaderFooterDisposition />
      </Route>
      {/* Legacy route to update */}
      <Route exact path={`${PROJECTS_ROUTE}/:projectSlug/layout/page/:id`}>
        <PlatformPageEdit />
      </Route>
    </Switch>
  );
}
export default ContentRoutes;
